/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productPreviewNodes = Array.from(document.querySelectorAll('.product-preview'));
if (productPreviewNodes.length) {
    import(/* webpackChunkName: "ProductPreview" */ './components/ProductPreview').then(({ default: ProductPreview }) => {
        productPreviewNodes.forEach((node) => render(<ProductPreview {...parseDataToProps(node.dataset)}/>, node));
    });
}
